export default
{
  aboutUs:
  {
    description: `
      <h3><b>تسهيل نمو وتطور</b> <br>المؤسسات التجارية في ليبيا.</h3>
      <br>
      <p style='font-weight: 300;'>نحن نساعد في تسهيل نمو وتطور المشاريع التجارية في ليبيا من خلال تكوين شراكات استراتيجية مع الشركات الدولية والمحلية في قطاعات الصناعة المستهدفة، بما في ذلك النفط والغاز والبنية التحتية والخدمات المالية.</p>
      <br>
      <div class="border-severus-gold border-t-[1.5px]"></div>
      <br>
      <p style='font-weight: 300;'>تركز أنشطة شركة سيفيروس ليبيا القابضة على تزويد شركائها بالمعرفة المحلية وشبكة اتصالات ودعم تشغيلي ورأس مال وهي الشركة الأولي للاستثمارات المشتركة والتي ستكون مطلوبة لإنشاء وتنمية مشاريع ناجحة في ليبيا.</p>`,
    reasons:
    {
      geographic:
      {
        title: "التغطية الجغرافية",
        text: "<p>تتمتع شركة سيفيروس ليبيا القابضة بحضور في طرابلس وبنغازي ودبي ومالطا، مما يوفر تغطية جغرافية للمناطق الرئيسية للمساعدة في تسهيل الاستثمار الأجنبي المباشر في ليبيا.</p>",
      },
      governance:
      {
        title: "الحوكمة",
        text: "<p>تحقق شركة سيفيروس ليبيا القابضة وتوفر معايير لا مثيل لها للحكم والسيطرة في ليبيا. من خلال شبكتنا من الشركاء المحليين والدوليين بالإضافة إلى فريقنا الخاص من المهنيين الماليين المقيمين في ليبيا ومالطا، نحن قادرون على توفير راحة البال لشركائنا الاستثماريين الدوليين.</p>",
      },
      infrastructure:
      {
        title: "البنية التحتية والاستثمارات",
        text: "<p>نحن نعمل بإجتهاد مع العديد من الشركاء الدوليين الرائدين لتطوير مشاريع البنية التحتية الكبيرة والاستثمارات الاستراتيجية.</p>",
      },
      international:
      {
        title: "الشركاء الدوليون",
        text: "<p>سيكون للشركاء الدوليين دور أساسي في توفير الخبرة لمساعدة البلاد، ونحن نعمل بشكل وثيق مع مثل هذه الشركات للاستثمار في ليبيا.</p>",
      },
      knowledge:
      {
        title: "المعرفة المحلية",
        text: "<p>نحن نزود الشركاء التجاريين بالمعرفة المحلية، وشبكة مراجع متاكملة، والدعم التشغيلي الميداني ورأس المال.</p>",
      },
    },
    subtitle: "في شركة سيفيروس ليبيا القابضة، نعمل على تحقيق الأهداف الحقيقية لليبيا",
    title: "معلومات عنا",
    titleImage: "about-us.ar.svg",
  },
  contactUs:
  {
    email: "البريد الالكتروني",
    generalInquiries: "الاستفسارات العامة",
    message: "رسالة",
    name: "الإسم",
    number: "رقم التواصل",
    send: "إرسال",
    subject: "الموضوع",
    title: "اتصل بنا",
    titleImage: "contact-us.ar.svg"
  },
  ourHistory:
  {
    description: "<p>تأسست مجموعة ليبيا القابضة في عام 2011 على يد أحمد بن حليم للاستفادة من الفرص الاستثمارية الناشئة التي تطورت في ليبيا بعد الثورة والتي لا تزال تتطور حتى اليوم.</p>",
    title: "تاريخنا",
    titleImage: "our-history.ar.svg",
  },
  ourStrategy:
  {
    mission:
    {
      description: "<p>تتمثل مهمة مجموعة ليبيا القابضة في تطوير مجموعة صناعية مربحة في ليبيا من خلال تركيز استراتيجيتنا على القطاعات التي تعتمد على انتعاش ونمو ليبيا مثل النفط والغاز والتصنيع والبنية التحتية والخدمات اللوجستية.</p>",
      title: "المهمة",
    },
    title: "استراتيجيتنا",
    titleImage: "our-strategy.ar.svg",
    values:
    {
      description: "<p>تسهيل نمو وتطور المشاريع التجارية في ليبيا من خلال تكوين شراكات استراتيجية مع الشركات العالمية والمحلية في الصناعات والقطاعات المستهدفة.</p>",
      title: "القيم",
    },
    vision:
    {
      description: "<p>تتمثل رؤيتنا في لعب دور إيجابي في إعادة إعمار ليبيا من خلال الاستثمار في الأعمال المربحة وإدارتها لصالح أصحاب المصلحة.</p>",
      title: "الرؤية",
    },
  },
  ourTeam:
  {
    title: "فريقنا",
    titleImage: "our-team.ar.svg",
    beaton:
    {
      name: "جراهام بيتون",
      position: "الرئيس التنفيذي للشؤون المالية",
      description: "<p>السيد بيتون هو محاسب قانوني مؤهل يتبع نهجًا تجاريًا لتحسين فعالية الوظائف المالية لتحسين أداء الأعمال.</p><p>يتمتع بخبرة واسعة النطاق، لا سيما في المنظمات المتعددة الجنسيات المعقدة العاملة في الأسواق الحدودية والناشئة، حيث يتمتع بخبرة تزيد عن 20 عامًا، خاصة في قطاعات الطاقة و النفط والغاز، حيث قاد عمليات إنجاز العديد من مشاريع البنية التحتية الكبيرة في بيئات مليئة بالتحديات.</p>",
    },
    edwards:
    {
      name: "ديفيد إدواردز",
      position: "الرئيس التنفيذي للعمليات",
      description: "<p>شغل السيد إدواردز عددًا من المناصب العليا على مدار الـ 25 عامًا الماضية، حيث شغل منصب المدير العام والمدير الإداري لقسم ضمن شركات Fortune 500 وFTSE 250. وقد ركزت هذه الأدوار بشكل خاص على الصناعة في توليد الطاقة وسلسلة التوريد والخدمات اللوجستية وقطاع الخدمات.</p><br><p>لقد عاش السيد إدواردز وعمل في جميع أنحاء أفريقيا والشرق الأوسط على مدى السنوات الخمس عشرة الماضية. وهو يركز الآن على ليبيا بالإضافة إلى توليه العديد من الأدوار الاستشارية وغير التنفيذية لمساعدة الشركات الدولية على دخول الأسواق الأفريقية.</p>",
    },
    halim:
    {
      name: "أحمد مصطفى بن حليم",
      position: "الرئيس التنفيذي",
      description: "<p>السيد أحمد بن حليم لديه خبرة فريدة من نوعها كمصرفي استثماري وإرث ليبي غني. يشارك في إدارة محفظة متنوعة تتجاوز قيمتها 7.5 مليار دولار من الأصول تحت الإدارة. ويمتلك فريقًا لامعًا يمتلك مجموعة واسعة من الخبرات في تنفيذ المشاريع الاستثمارية في بيئات الحدود.</p>",
    },    
    azzopardi:
    {
      name: "دارين أزوباردي",
      position: "المدير القانوني وأمين سر الشركة",
      description: "<p>الدكتور دارين أزوباردي LL.D. هو خريج قانون مع التركيز على صياغة العقود وحوكمة الشركات وإدارة الأعمال.</p><p>وقد شغل منصبًا إداريًا عليا لأكثر من 10 سنوات، حيث تولى أدوار المستشار العام وأمين سر الشركة لعدد من الكيانات التي يوجد مقرها في مالطا.</p><p>كما أنه يتمتع بخبرة تجارية في مجال تطوير وإدارة العقارات، حيث أشرف على الاستحواذ على عدد من العقارات (السكنية والتجارية) وتنفيذ المشاريع اللاحقة، بما في ذلك التخطيط والتصميم والتطوير.</p>",
    },    
  },
  portfolioCompanies:
  {
    readMore: "إقرأ المزيد",
    titleImage: "portfolio-companies.ar.svg",
    goToWebsite: "الذهاب إلى الموقع",
    investorPortal: "بوابة المستثمر",
    investorPortalModal: {
      signIn: "الوصول إلى البوابة",
      registerNewAccount: "تسجيل حساب جديد",
      registerTitle: "تسجيل حساب جديد",
      registerInstructions: "يرجى إكمال جميع الحقول المطلوبة أدناه. بمجرد الإرسال، سنراجع النموذج الخاص بك وترسل لك تفاصيل تسجيل الدخول عبر البريد الإلكتروني. يمكنك بعد ذلك تسجيل الدخول إلى حسابك للوصول إلى البوابة وعرض مستنداتك.",
      firstName: "الاسم الأول*",
      lastName: "اسم العائلة*",
      organization: "المنظمة",
      jobTitle: "المسمى الوظيفي",
      emailAddress: "عنوان البريد الإلكتروني*",
      submit: "إرسال",
      thankYouTitle: "شكراً لك. لقد استلمنا تفاصيلك.",
      thankYouMessage: "بمجرد المراجعة، سنرسل لك معلومات تسجيل الدخول عبر البريد الإلكتروني. يمكنك بعد ذلك تسجيل الدخول إلى حسابك للوصول إلى البوابة وعرض مستنداتك.",
      close: "إغلاق"
    },
    intro: "<span class='font-semibold'><span class='text-severus-gold'>منذ عام 2015،</span> قامت شركة <br class='md:hidden'>سيفيروس ليبيا القابضة <br>والشركات الشريكة لها <br class='md:hidden'>بتسهيل نمو وتطوير ما يلي:</span>",
    introOld: "منذ عام 2015، قامت شركة سيفيروس ليبيا القابضة والشركات الشريكة لها بتسهيل نمو وتطوير ما يلي:",
    location: "الموقع",
    title: "الشركات التابعة للمحفظة",
    ssc:
    {
      title: "مراكز الخدمة المشتركة",
      description: "<p>تدير مجموعة LHS مركزين (2) للخدمات المشتركة، أحدهما في مالطا والآخر في الإمارات العربية المتحدة، مما يسمح لها بدعم عملياتها في ليبيا.</p>",
    },
    agrico:
    {
      title: "شركة الزراعة",
      description: "<p>مجموعة LHS ملتزمة بتطوير مشاريع زراعية مستدامة في ليبيا، مستفيدة من الظروف الممتازة للزراعة على نطاق واسع. تمتلك مجموعتنا فريق ذو خبرة يبحث عن المشاريع ونتوقع الإعلان عن تقدم في هذا القسم الجديد قريبًا.</p>",
    },
    lorasco:
    {
      title: "لوراسكو",
      description: "<p>أسست شركة سيفيروس ليبيا القابضة (LHS) شركة LORASCO في عام 2016 لتطوير شركة رائدة في النشاط الخاص لتقديم خدمات الحفر للشركات النفطية في ليبيا. استحوذت شركة LORASCO على ثلاث (3) حفارات برية، وهي حالياً في طور تطوير قاعدة عملائها في ليبيا.</p>",
    },    
    ghibli:
    {
      title: "قبلي لخدمات القوى العاملة",
      description: "<p>توفر قبلي القوى العاملة المتخصصة والطاقة المتنقلة وخدمات الأعمال لقطاعات النفط والغاز والطاقة والبناء والاتصالات والخدمات اللوجستية. تمتلك شركة قبلي لخدمات القوى العاملة لها مكاتب في طرابلس وبنغازي ومصراتة.</p>",
    },    
    bisa:
    {
      title: "شركة بنغازي الدولية للتوكيلات الملاحية",
      description: "<p>شركة بنغازي الدولية للتوكيلات الملاحية (بيزا)، هي شركة متخصصة في الشحن البحري والخدمات اللوجستية، و مقرها الرئيسي في بنغازي، حيث تقدم خدماتها في كم من موانئ جليانة وطبرق. بفضل فريق مفعم بالعاطفة، واسع النطاق في المعرفة والخبرة، أصبحت شركة بنغازي الدولية للتوكيلات الملاحية (بيزا) الشريك المفضل للعملاء الذين يبحثون عن الخدمات في شرق ليبيا. نحن بحزم نعتقد أنه لا يوجد عميل كبير جدًا أو صغير، ونحن متخصصون في تطوير علاقات طويلة الأمد مع شركات متعددة الجنسيات وعملاء وكالات دولية. كجزء من مجموعة سفيروس ليبيا القابضة، تقدم شركة بنغازي الدولية للتوكيلات الملاحية (بيزا) للعملاء ميزة الخدمة الشاملة والعروض التي تلبي احتياجاتهم في جميع أنحاء البلاد. من البداية إلى النهاية، تلتزم (بيزا) بتقديم خدمات شحن استثنائية وحلول لوجستية فعالة.</p>",
    },    
  },
  ourSuccesses:
  {
    title: "شركة الإسمنت الليبية",    
    titleImage: "our-successes.ar.svg",
    companies: "lcc,aggreko",
    lcc:
    {
      title: "شركة الإسمنت الليبية",  
      mobileTitle: "شركة الإسمنت الليبية",    
      intro: 'يسر شركة LH Severus (LHS) أن تعلن عن "صفقة دورة كاملة"، وهي الأولى من نوعها في ليبيا منذ عام 2011، والتي تنطوي على بيع شركة الإسمنت الليبية (LCC).',
      description: "<p>بعد استحواذها على شركة الإسمنت الليبية في عام 2015، واصلت LHS - باعتبارها أكبر مستثمر - زيادة نمو الإنتاج بمقدار ستة أضعاف، وزيادة صافي سعر المبيعات بمقدار 13 مرة، وإرجاع أرباح جذابة لمجموعة المستثمرين الخاصة بها.</p><p>شركة الإسمنت الليبية هي أكبر منتج للإسمنت في ليبيا. تمتلك الشركة قدرة إنتاجية تبلغ 2.7 مليون طن عبر 3 مصانع تقع في بنغازي - الهواري و الفتائح في شرق ليبيا. توظف شركة الإسمنت الليبية أكثر من 2000 شخص مما يجعلها أكبر جهة توظيف في القطاع الخاص في شرق ليبيا.</p><p>لمزيد من المعلومات بشأن تشغيل وبيع الشركة الأهلية للأسمنت، يُرجى عدم التردد في التواصل معنا عبر هذا الرابط</p>",
    },
    aggreko:
    {
      title: "أجريكو",      
      mobileTitle: "أجريكو",
      intro: "في عام 2012، قامت شركة LH Severus، بالتعاون مع شركة Aggreko plc، أكبر مؤسسة عالمية لحلول الطاقة المتنقلة، بتنفيذ محطات كهرباء مركزية للكهرباء، محطة في منطقة أبو كماش و محطة في هون، بإجمالي 120 ميجاوات.",
      description: "<p>ساهمت هذه المحطات الكهربائية المتنقلة في استقرار الشركة العامة للكهرباء في ليبيا وفي نقل الكهرباء إلى جميع أنحاء البلاد، بينما كانت تُنفذ أعمال صيانة وإصلاح أكثر شمولاً لشبكة الكهرباء على المستوى الوطني.</p><p>تم تفكيك المحطات الكهربائية المؤقتة بنجاح في عام 2017، بعد أن أدّت دوراً حيوياً في استقرار شبكة الكهرباء في ليبيا.</p>",
    },
  },
  siteFooter:
  {
    address:
    {      
      list: "malta",
      malta:
      {
        name: "مالطا",
        number: "هاتف: +356 2122 4361",
        postal: "189، جناح 11، أجنحة مارينا<br>شارع مارينا، بيتا مالط",
      },      
    },
    cities: {
      malta: "مالطا",
      benghazi: "بنغازي",
      tripoli: "طرابلس",
      dubai: "دبي"
    }
  },
  siteHeader:
  {
    links:
    {
      about: "معلومات عنا",
      aboutLink: "معلومات عنا",
      contact: "اتصل بنا",
      contactLink: "اتصل بنا",
      portfolio: "محفظة الشركات و المشاريع",
      portfolioLink: "شركات المحفظة",
      strategy: "استراتيجيتنا",
      strategyLink: "استراتيجيتنا",
      team: "فريقنا",
      teamLink: "فريقنا",
      successes: "نجاحاتنا",
      successesLink: "our-successes",
      lls: "شركة الإسمنت الليبية",
      llsLink: "lcc",
      aggreko: "أجريكو",
      aggrekoLink: "aggreko"
    }
  },
  videoCarousel:
  {
    banner: "تهدف شركة سيفيروس ليبيا القابضة إلى أن تكون الشريك الاستثماري<br>للشركات العالمية الرائدة الراغبة في خدمة السوق الليبي.",
    desktop:
    {
      bisa:
      {
        image: "bisa.ar.svg",
      },
      ghibli:
      {
        image: "ghibli.ar.svg",
      },
      lcc:
      {
        image: "lcc.ar.svg",
      },
      lorasco:
      {
        image: "lorasco.ar.svg",
      },
      mstc:
      {
        image: "mstc.ar.svg",
      },
    },
    mobile:
    {
      bisa:
      {
        button:
        {
          left: "auto",
          right: "11%",
        },
        image: "bisa.m.ar.svg",
      },
      ghibli:
      {
        image: "ghibli.m.ar.svg",
      },
      lcc:
      {
        button:
        {
          left: "auto",
          right: "11%",
        },
        image: "lcc.m.ar.svg",
      },
      lhs:
      {
        video: "lhs.m.ar.mp4",
      },
      lorasco:
      {
        image: "lorasco.m.ar.svg",
      },
      mstc:
      {
        image: "mstc.m.ar.svg",
      },
    },
    readMore: "إقرأ المزيد",
  },
  whyLibya:
  {
    reasons:
    {
      broadAndDeep:
      {
        description: "<p>إن الفرصة المتاحة في ليبيا واسعة وعميقة على حد سواء، حيث تم إهمال الاستثمار في البلاد لعقود في عدد من القطاعات الصناعية الرئيسية.</p><br><p>ليبيا لديها ثروة من الموارد الطبيعية لها مستقبل في تطويرها وإعادة إعمارها بعد الثورة الأخيرة.</p><br><p>تحتاج ليبيا إلى مئات المليارات من الدولارات من الاستثمارات على مدى العقد المقبل، وتحتاج إلى قدرات وتكنولوجيا الشركات الأجنبية لتحقيق التقدم الاجتماعي والاقتصادي الذي يتطلبه شعبها.</p>",
        title: "فرصة واسعة<br>وعميقة",
      },
      lowCompetition:
      {
        description: "<p>لا توجد طبقة تجارية تذكر على المستوى المحلي في ليبيا بسبب الطبيعة الشمولية للنظام السابق.</p><br><p>وهذا يعني أن هناك عددًا قليلاً من المنافسين محليًا الذين يتمتعون بالقدرات اللازمة لاغتنام الفرص في ليبيا.</p><br><p>ستتطلب القوانين المحلية أن تعمل معظم الشركات مع شريك محلي وتكون الخيارات المتاحة لها غير كافية للطلب.</p>",
        title: "منافسة<br>منخفضة",
      },
      oilCountry:
      {
        description: "<p>تعتمد ليبيا على قطاع النفط في 95% من عائدات التصدير، و25% من ناتجها المحلي الإجمالي، و80% من إيرادات الحكومة، ولكن لم يتم استكشاف سوى 25% من أراضيها حتى الآن.</p><br><p>قطاعها النفطي متخلف حيث كان الإنتاج في انخفاض خلال معظم السنوات الأربعين الماضية ولم يتم استخدام تقنيات الإنتاج المتقدمة.</p><br><p>قطاع البتروكيماويات ليس متطورًا مثل سوق النفط والغاز في البلاد.</p>",
        title: "بلد النفط",
      },
      strategicLocation:
      {
        description: "<p>موقع ليبيا مع أكثر من 2000 كيلومتر من الساحل المواجه لأوروبا له أهمية استراتيجية. وتتمتع بإمكانية الوصول إلى الأسواق غير الساحلية الكبيرة والمتنامية في أفريقيا، جنوب الصحراء الكبرى، فضلاً عن كونها تبعد 280 كيلومتراً فقط عن الاتحاد الأوروبي. وهذا يجعل من ليبيا مركز الاستثمار الطبيعي الذي يربط بين العالم المتقدم والعالم النامي.</p>",
        title: "موقع<br>استراتيجي",
      },
    },
    title: "Why Libya?",
    titleImage: "why-libya.ar.svg",
  },
};
